module.exports = __webpack_public_path__ + "img/thumb_11.fc3fc4e6.jpg";